export class ProfessionalAssociationVM {
  id: any;
  name?: string;
  membershipType?: string;
  position?: number;
  runPublishingValidators?: boolean;
}
